import { ApiResponse, TicketManagerProject } from '@vision/ui/interfaces';
import { createHttpExtraOptions } from '../../../utils';
import { TicketManagerApi } from '../ticket-manager.api';
import {
  TicketManagerProjectCreateArgs,
  TicketManagerProjectDeleteArgs,
  TicketManagerProjectUpdateArgs,
  TicketManagerProjectsArgs,
} from './projects.api.types';
import { normalizeTicketManagerProjectResponse, normalizeTicketManagerProjectsResponse } from './projects.mappers';
import {
  buildCreateProjectRequest,
  buildDeleteProjectRequest,
  buildGetProjectsRequest,
  buildUpdateProjectRequest,
} from './projects.routes';

export const ProjectEndpoints = TicketManagerApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteTicketManagerProject: builder.mutation<void, TicketManagerProjectDeleteArgs>({
      query: (args) => ({
        ...buildDeleteProjectRequest(args),
        extraOptions: createHttpExtraOptions({
          notification: { autoHandleError: false, autoHandleSuccess: false },
        }),
      }),
      invalidatesTags: (_result, error) => (error ? [] : [{ type: 'TicketManagerProjectList', id: 'LIST' }]),
    }),

    ticketManagerProjects: builder.query<ApiResponse<TicketManagerProject[]>, TicketManagerProjectsArgs>({
      query: ({ accountId, query }) => buildGetProjectsRequest({ accountId, query }),
      transformResponse: normalizeTicketManagerProjectsResponse,
      providesTags: [{ type: 'TicketManagerProjectList', id: 'LIST' }],
    }),

    createTicketManagerProject: builder.mutation<ApiResponse<TicketManagerProject>, TicketManagerProjectCreateArgs>({
      query: ({ accountId, name, ownerId, ticketPrefix }) => ({
        ...buildCreateProjectRequest({ accountId, name, ownerId, ticketPrefix }),
        extraOptions: createHttpExtraOptions({
          notification: {
            autoHandleError: false,
          },
        }),
      }),
      transformResponse: normalizeTicketManagerProjectResponse,
      invalidatesTags: [{ type: 'TicketManagerProjectList', id: 'LIST' }],
    }),

    updateTicketManagerProject: builder.mutation<ApiResponse<TicketManagerProject>, TicketManagerProjectUpdateArgs>({
      query: ({ accountId, name, projectId, ticketRefIdTemplate }) => ({
        ...buildUpdateProjectRequest({ accountId, name, projectId, ticketRefIdTemplate }),
        extraOptions: createHttpExtraOptions({
          notification: {
            autoHandleError: false,
          },
        }),
      }),
      transformResponse: normalizeTicketManagerProjectResponse,
      invalidatesTags: [{ type: 'TicketManagerProjectList', id: 'LIST' }],
    }),
  }),
});

export const {
  useDeleteTicketManagerProjectMutation,
  useLazyTicketManagerProjectsQuery,
  useCreateTicketManagerProjectMutation,
  useUpdateTicketManagerProjectMutation,
} = ProjectEndpoints;
